import googleAnalytics4Event from './redux/actions';

require('./redux/beaconMiddleware');

export default googleAnalytics4Event;
